import { AttributeEditModeConfig } from '@source-components-react/types';
import {
  TEXT_SHOW_LESS_LABEL_ATTRIBUTE,
  TEXT_SHOW_MORE_AFTER_ATTRIBUTE,
  TEXT_SHOW_MORE_LABEL_ATTRIBUTE,
} from './text-attributes';

export const attributeEditModeConfigs: AttributeEditModeConfig[] = [
  {
    name: 'content-text-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'enclosing-tag-3-resolutions',
    heading: 'Enclosing Tag',
    subHeading:
      'HTML tag to enclose the text in (e.g. p, h1, span); see ENCLOSING_TAGS for the allowed values, for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'links-3-resolutions',
    heading: 'Links',
    subHeading:
      'Links this text can point at. To link part of the text, wrap those words in {1|linked text}, where the number is the position of the entry in this list counting from 1; clearing an entry leaves its position in place so the other numbers keep pointing where they did, for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'inline-styles-3-resolutions',
    heading: 'Class Names & Styles',
    subHeading:
      'Class names and CSS this text can apply to part of itself, e.g. to give a few words their own colour. To apply an entry, wrap those words in {.1|styled text}, where the number is the position of the entry in this list counting from 1; clearing an entry leaves its position in place so the other numbers keep pointing where they did, for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: TEXT_SHOW_MORE_AFTER_ATTRIBUTE,
    heading: 'Show More After',
    subHeading:
      'How many characters a reader sees before the rest is hidden behind Show more. The count is the characters they read — markers and fillers already applied — and the cut ends on a whole word; leave empty to always show all of it, for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: TEXT_SHOW_MORE_LABEL_ATTRIBUTE,
    heading: 'Show More Label',
    subHeading:
      'The words on the toggle while the text is collapsed. Supports the {b|…}, {i|…} and {.1|…} markers against this text\'s Class Names & Styles list, but not links; leave empty for "Show more", for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: TEXT_SHOW_LESS_LABEL_ATTRIBUTE,
    heading: 'Show Less Label',
    subHeading:
      'The words on the toggle while the text is expanded. Supports the {b|…}, {i|…} and {.1|…} markers against this text\'s Class Names & Styles list, but not links; leave empty for "Show less", for 3 different device resolutions',
    defaultValues: {},
  },
];
